import { render, staticRenderFns } from "./CarrelloLayout.vue?vue&type=template&id=03b080fe&scoped=true&"
import script from "./CarrelloLayout.vue?vue&type=script&lang=js&"
export * from "./CarrelloLayout.vue?vue&type=script&lang=js&"
import style0 from "./CarrelloLayout.vue?vue&type=style&index=0&id=03b080fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b080fe",
  null
  
)

export default component.exports